/*
 * dark.jsx 05.12.2017
 *
 * (c) 2017 ergovia GmbH
 */
import {createMuiTheme} from '@material-ui/core/styles/index';

export const darkTheme = createMuiTheme({
    palette: {
        background: {
            paper: '#3F3F4E',
            default: '#DADDE4'
        },
        primary: {
            main: '#3F3F4E',
            contrastText: '#FFFFFF'
        },
        text: {
            primary: '#FFFFFF',
            secondary: '#3F3F4E',
            disabled: '#CCCCCC'
        }
    },
    typography: {
        fontFamily: '"Roboto"',

        body1: {
            fontFamily: '"Roboto"',
            fontSize: 18
        },

        body2: {
            fontFamily: '"Roboto"'
        },
        display1: {
            fontFamily: '"Roboto"'
        },
        display2: {
            fontFamily: '"Roboto"'
        },
        display3: {
            fontFamily: '"Roboto"'
        },
        display4: {
            fontFamily: '"Roboto"'
        },
        headline: {
            fontFamily: '"Roboto"'
        },
        subheadline: {
            fontFamily: '"Roboto"'
        },
        title: {
            fontFamily: '"Roboto"'
        }
    },

    shape: {
        borderRadius: 8
    },
    overrides: {
        MuiTableCell: {
            head: {
                color: '#FFFFFF'
            }
        }
    }
});



// WEBPACK FOOTER //
// ./src/de/ergovia/themes/dark.js